// extracted by mini-css-extract-plugin
module.exports = {"textarea":"src-components-atoms-Textarea-___style__textarea___1-A6P"};